// src/components/layouts/AdminLayout.jsx

import { useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import AdminNavbar from '../admin/AdminNavbar';
import AdminSidebar from './AdminSidebar';

/**
 * Admin layout component that wraps admin pages with sidebar navigation
 * @returns {JSX.Element} AdminLayout component
 */
const AdminLayout = () => {
  const { user, signOut } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  /**
   * Handle user logout
   * @returns {Promise<void>}
   */
  const handleLogout = async () => {
    try {
      await signOut();
      navigate('/');
      // Clear any admin-specific data on logout
      localStorage.removeItem('cartItems');
      localStorage.removeItem('adminPreferences');
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  /**
   * Toggle sidebar visibility (mobile)
   */
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Admin Top Navigation Bar */}
      <AdminNavbar
        user={user}
        handleLogout={handleLogout}
        toggleSidebar={toggleSidebar}
        sidebarOpen={sidebarOpen}
      />

      <div className="flex">
        {/* Admin Sidebar */}
        <AdminSidebar
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
        />

        {/* Main Content Area */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* Admin Content Wrapper */}
          {/* Page Content */}
          <main className="flex-1 overflow-hidden">
            <Outlet />
          </main>
        </div>
      </div>

      {/* Overlay for mobile sidebar */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-gray-600 bg-opacity-50 z-20 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* <Footer /> */}
    </div>
  );
};

export default AdminLayout;
